// import { CriteriaCell } from '@/components/MeasurementDatagird/CriteraiCell'
import { Box, Card, Stack, Typography } from '@mui/material'
import { useGetCriteriaLabel } from 'app/hooks/useAnalyzer'

export const BMISection = ({ data }) => {
    const { format } = useGetCriteriaLabel()
    return (
        <Card
            component={'section'}
            sx={{
                backgroundColor: '#4A4949',
                color: 'white',
                pageBreakInside: 'avoid',
            }}
        >
            <Stack p={2} spacing={2}>
                <Typography variant="body1" component={'h2'}>
                    ดัชนีมวลกาย (BMI)
                </Typography>
                <Stack direction={'row'} spacing={2}>
                    <Typography variant="h2" flexGrow={1} textAlign={'start'}>
                        {data?.find((item) => item.name === 'BMI')?.value ||
                            '- -'}
                    </Typography>
                    <Typography variant="h2">
                        {format(data || []).label}
                    </Typography>
                </Stack>
                <Stack direction={'row'} spacing={0.5}>
                    {/* TODO: color section the active bmi  */}
                    <Box
                        sx={{
                            width: '100%',
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: '#00C7F3',
                        }}
                    />
                    <Box
                        sx={{
                            width: '100%',
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: '#8AC53E',
                        }}
                    />
                    <Box
                        sx={{
                            width: '100%',
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: '#FFC000',
                        }}
                    />
                    <Box
                        sx={{
                            width: '100%',
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: '#FF7E07',
                        }}
                    />
                    <Box
                        sx={{
                            width: '100%',
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: '#FF0707',
                        }}
                    />
                </Stack>
            </Stack>
        </Card>
    )
}
